import React from 'react'
import './Loader.css'

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-[30vh]">
        <span className="loader"></span>
    </div>
  )
}

export default Loader